import { InputProps } from '@/shared/types/CommonTypes';
import { cn } from '@/shared/utils/cn';

const Input = ({
  label,
  error,
  helperText,
  fullWidth = true,
  className,
  labelClassName,
  ref,
  ...props
}: InputProps) => {
  return (
    <div className={cn('text-left', fullWidth && 'w-full')}>
      {label && (
        <label
          htmlFor={props.id || props.name}
          className={cn(
            'ml-2 font-semibold leading-[1.4] text-[#444]',
            'text-[14px]',
            labelClassName,
          )}
        >
          {label}
        </label>
      )}

      <input
        ref={ref}
        className={cn(
          'mt-1 h-10 rounded-full border border-[#ddd] px-6 text-[14px] text-[#444] focus:outline-none',
          fullWidth && 'w-full',
          error && 'border-red-500',
          className,
        )}
        {...props}
      />

      {helperText && !error && (
        <p className="ml-2 mt-2 text-[12px] font-normal text-[#999]">
          {helperText}
        </p>
      )}
      {error && <p className="ml-2 mt-1 text-xs text-red-500">{error}</p>}
    </div>
  );
};

export default Input;
